"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBMenuPopover = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var mock_1 = require("../../utils/mock");
var position_1 = require("../../utils/position");
var StyledMenu = styled_components_1.default(function (_a) {
    var width = _a.width, rest = __rest(_a, ["width"]);
    mock_1.mockFunction({ width: width });
    return jsx_runtime_1.jsx(core_1.Menu, __assign({}, rest, { anchor: true }), void 0);
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: ", ";\n  .MuiMenu-paper {\n    width: ", ";\n  }\n"], ["\n  z-index: ", ";\n  .MuiMenu-paper {\n    width: ",
    ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.zIndex.layer[10];
}, function (_a) {
    var width = _a.width;
    return width ? (typeof width === 'string' ? width : width + "px") : 'unset';
});
var MBMenuPopover = function (_a) {
    var anchorEl = _a.anchorEl, open = _a.open, onClose = _a.onClose, _b = _a.keepMounted, keepMounted = _b === void 0 ? true : _b, children = _a.children, width = _a.width, _c = _a.anchorOrigin, anchorOrigin = _c === void 0 ? {
        vertical: 'bottom',
        horizontal: 'left',
    } : _c, _d = _a.transformOrigin, transformOrigin = _d === void 0 ? {
        vertical: 'top',
        horizontal: 'left',
    } : _d, offset = _a.offset, PaperProps = _a.PaperProps, ModalProps = _a.ModalProps;
    var anchorPosition = react_1.useMemo(function () {
        if (!offset || !anchorEl)
            return undefined;
        var _a = position_1.getAbsolutePosition(anchorEl), top = _a.top, right = _a.right, left = _a.left, bottom = _a.bottom;
        var vertical = anchorOrigin.vertical, horizontal = anchorOrigin.horizontal;
        switch (vertical) {
            case 'bottom':
                switch (horizontal) {
                    case 'left':
                        return { top: bottom + offset.top, left: left + offset.left };
                    case 'right':
                        return { top: bottom + offset.top, left: right + offset.left };
                    default:
                        return { top: bottom + offset.top, left: right + offset.left };
                }
            case 'top':
                switch (horizontal) {
                    case 'left':
                        return { top: top + offset.top, left: left + offset.left };
                    case 'right':
                        return { top: top + offset.top, left: right + offset.left };
                    default:
                        return { top: top + offset.top, left: right + offset.left };
                }
            default:
                switch (horizontal) {
                    case 'left':
                        return { top: top + offset.top, left: left + offset.left };
                    case 'right':
                        return { top: top + offset.top, left: right + offset.left };
                    default:
                        return { top: top + offset.top, left: right + offset.left };
                }
        }
    }, [anchorEl, offset]);
    var hasOpenProps = typeof open === 'boolean';
    var anchorProps = offset && anchorPosition
        ? {
            anchorReference: 'anchorPosition',
            anchorPosition: anchorPosition,
        }
        : {
            anchorReference: 'anchorEl',
        };
    if (!anchorEl) {
        return null;
    }
    return (jsx_runtime_1.jsx(StyledMenu, __assign({ id: "single-menu", width: width, anchorEl: anchorEl, keepMounted: keepMounted, open: hasOpenProps ? open : Boolean(anchorEl), onClose: onClose, anchorOrigin: anchorOrigin, transformOrigin: transformOrigin, getContentAnchorEl: null }, anchorProps, { PaperProps: PaperProps }, ModalProps, { children: children }), void 0));
};
exports.MBMenuPopover = MBMenuPopover;
var templateObject_1;
//# sourceMappingURL=MBMenuPopover.js.map